import styled from "styled-components";

export const InputRadioGropuStyles = styled.div`
  @media screen and (max-width: 576px) {
    label {
      font-size: 13px;
    }
  }
`;
